import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = {
  class: "opModal formContainer",
  style: {"width":"720px"}
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = {
  key: 0,
  class: "text-center py-4 text-muted"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_10 = { class: "table table-sm" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = { class: "fw_600 fs_14" }
const _hoisted_14 = { class: "text-muted fs_12" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = { value: "" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Import DD documents",
          text: "Import DD documents"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.preview.matched.length === 0 && _ctx.preview.unmatched.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_localized_text, {
              localizedKey: "No certificate documents to import.",
              text: "No certificate documents to import."
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.rows.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("table", _hoisted_10, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_11,
                        _createElementVNode("th", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Document",
                            text: "Document"
                          })
                        ]),
                        _createElementVNode("th", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Expiration Date",
                            text: "Expiration Date"
                          })
                        ]),
                        _createElementVNode("th", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Certification",
                            text: "Certification"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, i) => {
                        return (_openBlock(), _createElementBlock("tr", { key: i }, [
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => ((row.include) = $event)
                            }, null, 8, _hoisted_12), [
                              [_vModelCheckbox, row.include]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_13, _toDisplayString(row.item.ddText), 1),
                            _createElementVNode("div", _hoisted_14, _toDisplayString(row.item.fileName), 1)
                          ]),
                          _createElementVNode("td", null, [
                            (row.item.expirationDate)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$filters.date(row.item.expirationDate, "DD.MM.YYYY")), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_16, "--"))
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("select", {
                              class: "form-select form-select-sm",
                              "onUpdate:modelValue": ($event: any) => ((row.targetKey) = $event)
                            }, [
                              _createElementVNode("option", _hoisted_18, "-- " + _toDisplayString(_ctx.$localizationService.getLocalizedValue('Select', 'Select')) + " --", 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preview.availableTargets, (t, ti) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: ti,
                                  value: _ctx.targetKey(t)
                                }, _toDisplayString(t.categoryTitle) + " / " + _toDisplayString(t.certificationName), 9, _hoisted_19))
                              }), 128))
                            ], 8, _hoisted_17), [
                              [_vModelSelect, row.targetKey]
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-tertiary",
                disabled: _ctx.selectedCount === 0,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.apply()))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Import",
                  text: "Import"
                }),
                _createTextVNode(" (" + _toDisplayString(_ctx.selectedCount) + ") ", 1)
              ], 8, _hoisted_21)
            ])
          ]))
    ])
  ]))
}